export default __webpack_public_path__ + "static/media/fv_rules.838066e4.svg";